/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('../../node_modules/overlayscrollbars/js/OverlayScrollbars');
window.Vue = require('vue');

import Vuetify from 'vuetify';
Vue.use(Vuetify);

import moment from 'moment';

import { Form, HasError, AlertError } from 'vform';
window.Form = Form;

import Gate from "./Gate";
Vue.prototype.$gate = new Gate(window.user);

import Swal from 'sweetalert2';

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import $ from "jquery";
window.$ = window.jQuery = $;
require('admin-lte');
import { getMonthInterval } from './helpers/dateHelper';
Vue.prototype.$getMonthInterval = getMonthInterval;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})
window.Swal = Swal;
window.Toast = Toast;

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px'
});

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)
// Event Bus
import { EventBus } from './event-bus'
Vue.prototype.$bus = EventBus

// Global Modal State
Vue.prototype.$modal = Vue.observable({
    open: false,
    title: '',
    component: null,
    props: {},
    width: 600
})

// Modal Component (global)
Vue.component('global-modal', require('./base-components/BaseModal.vue').default)

/**
 * Routes imports and assigning
 */
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import routes from './routes';
import Vue from 'vue';

const router = new VueRouter({
    mode: 'history',
    base: process.env.MIX_VUE_APP_BASE_URL || '/',
    routes
});
// Routes End
// Global Route Guard
router.beforeEach((to, from, next) => {
    const user = window.user;

    // 1. Cek jika route membutuhkan permission spesifik
    if (to.meta.permission) {
        const permissionKey = to.meta.permission;
        const allowed = user?.roles?.[permissionKey] === 1;

        if (!allowed) {
            return next({ name: 'not-allowed' });
        }
    }

    // 2. Cek jika route membutuhkan admin (roles_id = 1 atau 2)
    if (to.matched.some(record => record.meta.requiresAdmin)) {
        if (!Vue.prototype.$gate.isAdmin()) {
            return next({ name: 'not-allowed' });
        }
    }

    // 3. Cek jika route membutuhkan super admin / isAdmin khusus (roles_id = 1)
    if (to.matched.some(record => record.meta.requiresSuperAdmin)) {
        if (!Vue.prototype.$gate.isSuperAdmin()) {
            return next({ name: 'not-allowed' });
        }
    }

    // Jika semua aman, lanjut ke route
    next();
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


// Components
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('dashboard', require('./components/Dashboard.vue'));

Vue.component(
    'passport-clients',
    require('./components/passport/Clients.vue').default
);

Vue.component(
    'passport-authorized-clients',
    require('./components/passport/AuthorizedClients.vue').default
);

Vue.component(
    'passport-personal-access-tokens',
    require('./components/passport/PersonalAccessTokens.vue').default
);

Vue.component(
    'not-found',
    require('./components/NotFound.vue').default
);

Vue.component(
    'kantorswitcher',
    require('./components/KantorSwitcher.vue').default
);

// Filter Section

Vue.filter('myDate', function (created) {
    return moment(created).format('MMMM Do YYYY');
});

Vue.filter('indoDate', function (created) {
    return moment(created).format('YYYY/MM/DD  HH:mm:ss');
});

Vue.filter('yesno', value => (value ? '<i class="fas fa-check green"></i>' : '<i class="fas fa-times red"></i>'));

Vue.filter('toCurrency', function (value) {
    if (isNaN(parseFloat(value))) {
        return value;
    }
    var formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    });
    return formatter.format(value);
});

Vue.filter('zerofill', function (value) {
    var s = value + "";
    while (s.length < 6) s = "0" + s;
    return s;
});


EventBus.$on('modal:show', ({ title, component, props = {}, width = 600 }) => {
    Vue.prototype.$modal.open = false; // tutup dulu biar pasti remount

    // Delay sedikit agar remount dipicu
    setTimeout(() => {
        Vue.prototype.$modal.open = true;
        Vue.prototype.$modal.title = title;
        Vue.prototype.$modal.component = component;
        Vue.prototype.$modal.props = props;
        Vue.prototype.$modal.width = width;
        Vue.prototype.$modal.key = `modal-${Date.now()}`; // Tambahkan key
    }, 50);
});

EventBus.$on('modal:close', () => {
    Vue.prototype.$modal.open = false
})
const app = new Vue({
    el: '#app',
    vuetify: new Vuetify(),
    router
});

